import { useMemo } from "react";
import { Table } from "antd";

// Таблица в отчете
const SectionCustomReportTable = ({
  columns = [],
  rows = [],
  sum = [],
  expandedRowKeys = [],
}) => {
  // Формируем колонки
  const currentColumns = useMemo(
    () =>
      columns.map((col, index) => ({
        title: col.name,
        dataIndex: `col_${index}`,
        key: `col_${index}`,
      })),
    [columns]
  );

  // Формируем данные
  const dataSource = useMemo(() => {
    const data = rows.map((row, index) => {
      const rowData = { key: index };

      row.data.forEach((cell, cellIndex) => {
        rowData[`col_${cellIndex}`] = cell;
      });

      if (row.children?.length) {
        rowData.children = row.children.map((childRow, childIndex) => {
          const childRowData = { key: `${index}-${childIndex}` };
          childRow.forEach((cell, cellIndex) => {
            childRowData[`col_${cellIndex}`] = cell;
          });
          return childRowData;
        });
      }

      return rowData;
    });

    // Добавляем строку с суммами в конец, если есть
    if (sum?.filter(Boolean).length) {
      const sumRow = { key: "sum" };
      sum.forEach((cell, cellIndex) => {
        sumRow[`col_${cellIndex}`] = cell;
      });
      data.unshift(sumRow);
    }

    return data;
  }, [rows, sum]);

  return (
    <Table
      dataSource={dataSource}
      columns={currentColumns}
      pagination={false}
      size="small"
      scroll={{ x: "100%" }}
      expandable={{ expandedRowKeys }}
    />
  );
};

export default SectionCustomReportTable;
